import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import AppLayout from "../components/layout/AppLayout";
import AuthLayout from "../components/layout/AuthLayout";
import Login from "../pages/Login";
import TransactionSchedulePage from "../pages/TransactionSchedulePage";
import TransactionScheduleDashboardPage from "../pages/TransactionScheduleDashboardPage";
import UploadExcelAcc from "../pages/UploadExcel";
import UsersPage from "../pages/UsersPage";
import InstitutionAccountsPage from "../pages/institution/accounts/InstitutionAccountsPage";
import HeadInstitutionAccountsPage from "../pages/institution/accounts/HeadInstitutionAccountsPage";
import TransactionDataTablePage from "../pages/TransactionDataTablePage";
import InstitutionWalletsPage from "../pages/institution/wallets/InstitutionWalletsPage";
import AccountPage from "../pages/account/AccountPage";
import HeadInstitutionControllPage from "../pages/HeadInstitutionControllPage";
import SearchStatementsPage from "../pages/SearchStatementsPage";
import InstitutionManageAccountsPage from "../pages/admin/institutions/InstitutionManageAccountsPage";
import InstitutionsPage from "../pages/admin/institutions/InstitutionsPage";

import ROUTE_PATHS from "./routePaths";
import { getUserRoles } from "../api/auth";

function AdminOnlyRoute({ children }) {
  const token = localStorage.getItem("access_token");
  const roles = getUserRoles(token).map((r) => String(r).replace("ROLE_", ""));
  const isAdmin = roles.includes("ADMIN");

  return isAdmin
    ? children
    : <Navigate to={ROUTE_PATHS.TRANSACTION_SCHEDULE_DASHBOARD} replace />;
}

function AppRouter() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={ROUTE_PATHS.LOGIN} element={<Login />} />
      </Route>

      <Route element={<AppLayout />}>
        <Route
          path={ROUTE_PATHS.TRANSACTION_SCHEDULE_DASHBOARD}
          element={<TransactionScheduleDashboardPage />}
        />
        <Route
          path={ROUTE_PATHS.TRANSACTION_SCHEDULE}
          element={<TransactionSchedulePage />}
        />
        <Route
          path={ROUTE_PATHS.UPLOAD_EXCEL_ACC}
          element={<UploadExcelAcc />}
        />
        <Route
          path={ROUTE_PATHS.TRANSACTION_DATA_TABLE}
          element={<TransactionDataTablePage />}
        />
        <Route
          path={ROUTE_PATHS.INSTITUTION_ACCOUNTS}
          element={<InstitutionAccountsPage />}
        />
        <Route
          path={ROUTE_PATHS.INSTITUTION_HEAD_ACCOUNTS}
          element={<HeadInstitutionAccountsPage />}
        />
        <Route
          path={ROUTE_PATHS.INSTITUTION_WALLETS}
          element={<InstitutionWalletsPage />}
        />
        <Route
          path={ROUTE_PATHS.MANAGE_INSTITUTIONS}
          element={<HeadInstitutionControllPage />}
        />
        <Route
          path="/account/:bankAccountId"
          element={<AccountPage />}
        />
        <Route
          path={ROUTE_PATHS.SEARCH_STATEMENTS}
          element={<SearchStatementsPage />}
        />
        <Route
          path={ROUTE_PATHS.USERS}
          element={
            <AdminOnlyRoute>
              <UsersPage />
            </AdminOnlyRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.ADMIN_ACCOUNTS}
          element={
            <AdminOnlyRoute>
              <InstitutionManageAccountsPage />
            </AdminOnlyRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.ADMIN_INSTITUTIONS}
          element={
            <AdminOnlyRoute>
              <InstitutionsPage />
            </AdminOnlyRoute>
          }
        />
      </Route>

      <Route
        path="*"
        element={<Navigate to={ROUTE_PATHS.TRANSACTION_SCHEDULE_DASHBOARD} replace />}
      />
    </Routes>
  );
}

export default AppRouter;